module.exports = __webpack_public_path__ + "static/media/dropdown.3a7932e4.svg";